// 存放 Vue mixin 可混入的代码
// 本可做全局的混入，但是对于 Vue 理解还不足，所以 impor 导入方式
'use strict'
/**
 * 上传头像
 * zlh
 */
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import bus from '@/utils/bus'
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
export const mixinTrainingHome = {
  data() {
    return {
      sidebarSwitch: true,
      homeWorkStatus: false,
      blockXmlText: '',
      studentId: '',
      editorType: '',
      buildingBlocksTypeObj: {
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
    }
  },
  computed: {
    ...mapGetters(['accountInfo', 'hasRunSuccess', 'curriculumId', 'userRole']),
  },

  //生命周期 - 创建完成（可以访问当前this实例
  created() {
    let self = this
    let query = this.$route.query

    if (query) {
      this.editorType = query.editorType
    }
    if (query && query.scoreHandle) {
      //全局变量，判断是否为老师角色从评分进来
      this.$store.state.blocklyHome.scoreHandle = true
      this.scoreHandle = true
      this.$store.state.blocklyHome.studentId = query.studentId
      this.studentId = query.studentId
    } else {
      this.$store.state.blocklyHome.studentId = null
      this.scoreHandle = false
    }
    this.$store.state.blocklyHome.createBy = query.createBy

    if (query && query.curriculumId) {
      this.$store.state.blocklyHome.curriculumId = query.curriculumId
    } else {
      //此处有问题
      this.$store.state.blocklyHome.curriculumId = query.null
    }
    if (this.userRole != 2 && !query.scoreHandle) {
      this.popupActive = 'remind'
    }

    //监听保存项目代码
    bus.$on('aiEditorSaveFile', async (type) => {
      //在EditorIndex.vue处理保存项目功能;

      let result = await self.saveFile(type)
      if (result && result.isSuccess) {
        self.$message.success(result.returnMsg)
      } else {
        self.$message.error(result.returnMsg)
      }
    })
    //离开前监听
    bus.$on('beforeLeave', async (type) => {
      self.leaveType = type
      self.beforeLeave()
    })

    //监听 切换右侧工具栏的显示;
    bus.$on('changeRightSide', (val) => {
      self.rightSideVal = val
    })
    //监听 显示积木工作区
    bus.$on('changeWorkspace', (val) => {
      self.workspaceIsVisible = val
    })
    // window.onblur = function() {
    //     console.log('close--------')
    //     this.websocket.close()
    // }
  },
  async mounted() {
    let self = this,
      xmlText,
      projectInfoRes,
      taskRes,
      userId = this.accountInfo.userId,
      socket_basis = window.gtaAiConfig.socket_basis,
      host = window.location.host,
      // wsUrl = `${socket_basis}${userId}`;
      wsUrl =  `${window.location.protocol === 'https:' ? 'wss':'ws'}://${host}${socket_basis}/websocket/${userId}`;
    this.homeWorkStatus = this.$store.state.blocklyHome.homeWorkStatus
    self.createWebSocket(wsUrl) //混合模式载入
    this.getMedia()

    // //调用获取项目信息接口
    // projectInfoRes = await this.getProjectInfo()
    // //调用获取实训任务信息接口
    // taskRes = await this.getTaskInfoByTrainingId()
    // if (this.scoreHandle) {
    //   projectInfoRes = taskRes
    // }
    // if (this.trainingId) {
    //   if (this.userRole != 2) {
    //     //老师角色 进入自己的实训时，工作台初始化显示最新保存的积木；
    //     xmlText = projectInfoRes.data.buildingBlocks
    //   } else if (this.userRole == 2) {
    //     if (taskRes && taskRes.data && taskRes.data.buildingBlocks) {
    //       xmlText = taskRes.data.buildingBlocks // 获取作业任务信息
    //     } else if (
    //       projectInfoRes &&
    //       projectInfoRes.data &&
    //       projectInfoRes.data.buildingBlocks
    //     ) {
    //       //优先获取自己保存的积木
    //       xmlText = projectInfoRes.data.buildingBlocks
    //     }
    //   }
    //   if (projectInfoRes.data) {
    //     this.pythonEditorCode = projectInfoRes.data.pythonBlocks
    //   }

    //   //调用BlocklyEditer.vue工作台生成积木方法
    //   if (xmlText) {
    //     this.blockXmlText = xmlText
    //     // this.$emit('createBlocksByWorkspaceXML', xmlText, true)
    //   }
    // }
  },
  methods: {
    componetsBlur() {
      // console.log('aaaaaaaaaaaa')
    },
    /**
     *
     *
     * websocket业务处理
     */
    leavePage(data) {
      let deleteTrainingId,
        trainingId = this.trainingId
      if (!data || !data.deleteTrainingId) {
        return
      }
      deleteTrainingId = data.deleteTrainingId
      if (deleteTrainingId === trainingId && this.userRole === 2) {
        this.$message.warning('该课程实训已被撤回或删除，页面将5s后退出')
        setTimeout(() => {
          this.confirmLeaveSave(false)
        }, 5000)
      }
    },

    // 解析socket返回的信息;
    socketInfoHandler(msg) {
      // let { videoAttr, video } = this
      // let _this = this
      // let infoList
      this.videoMsg = msg
      if (msg && msg.msg === 'success') {
        let attr = msg.attr
      }
    },
    //    取消弹窗
    cancelPopup() {
      this.popupActive = ''
      this.scoreForm = ''
    },
    //获取积木列表接口
    async getTrainingBlockList() {
      let userId = this.createBy || this.accountInfo.userId,
        data = {
          createBy: userId,
          quoteTrainId: this.quoteTrainingId,
        }

      return Promise.all([
        BLOCK.getBlockList(data), // 获取积木列表
        BLOCK.getModelBlockList(data), // 获取积木列表 -- 我的模型和公共模型部分
        BLOCK.getTrainModelBlockList(data), // 获取积木列表 -- 实训模型部分
      ]).then((values) => {
        // try {
        var Blocks = this.Blocks
        let blocksList = []
        for (let i = 0, len = values.length; len > 0 && i < len; i++) {
          if (values[i] && values[i].data && values[i].data instanceof Array) {
            blocksList = blocksList.concat(values[i].data)
          }
        }
        Blocks.Items = blocksList
        if (!sessionStorage.getBlockList) {
          sessionStorage.getBlockList = JSON.stringify(blocksList)
        }
        // console.log('blocksList:', blocksList)
        this.Blocks = Blocks
        // } catch (e) {}
      })
    },
    // //获取积木列表接口
    // async getBlockList() {
    //   let userId = this.createBy || this.accountInfo.userId,
    //     data = {
    //       createBy: userId,
    //     }
    //   let res = await BLOCK.getBlockList(data)
    //   if (res.isSuccess) {
    //     var Blocks = this.Blocks
    //     Blocks.TotalCount = res.data.length
    //     Blocks.Items = res.data
    //     if (!sessionStorage.getBlockList) {
    //       sessionStorage.getBlockList = JSON.stringify(res.data)
    //     }
    //     this.Blocks = Blocks
    //   }
    //   return res
    // },

    /**
   获取项目信息 @data createBy创建人id trainingId实训id
   */
    async getProjectInfo() {
      let res,
        userId = this.createBy || this.accountInfo.userId,
        data = {
          trainingId: this.trainingId,
          createBy: userId,
        }
      if (this.studentId) {
        data.createBy = this.studentId
      }
      res = await BLOCK.getProjectInfo(data)
      if (res.isSuccess) {
        // this.blockXmlText = res.data.buildingBlocks
        this.Project = res.data
        // if (res.data.score || res.data.score === 0) {
        //   this.$store.state.blocklyHome.homeWorkStatus = true
        //   this.homeWorkStatus = true
        // } else {
        //   this.$store.state.blocklyHome.homeWorkStatus = false;
        //   this.homeWorkStatus = false;
        // }
      }
      return res
    },
    runHandle() {
      return this.$refs.blocklyIndex.$refs.blockly.runHandle()
    },
    gethomeWorkStatus(val) {
      this.homeWorkStatus = val
      this.$store.state.blocklyHome.homeWorkStatus = val
    },
    // 根据实训id获取实训详情\信息 @data userId trainingId
    async getTaskInfoByTrainingId() {
      let { accountInfo, trainingId } = this,
        userId = this.studentId || accountInfo.userId,
        data = {
          trainingId: trainingId,
          userId: userId,
        },
        res
      res = await MARKCENTER.getTaskInfoByTrainingId(data)

      if (res && res.isSuccess) {
        this.taskInfo = res.data
        // this.blockXmlText = res.data.buildingBlocks
      }
      return res
    },
    beforeLeave() {
      if (this.scoreHandle) {
        this.$router.go(-1)
      } else {
        this.popupActive = 'leave-save'
      }
    },
    confirmLeaveSave: debounce(async function(val) {
      // async confirmLeaveSave(val) {
      let leaveType = this.leaveType
      let curriculumId = this.curriculumId
      // 点击删除按钮时，不退出页面，弹框消失；
      if (val === 'firstOff') {
        return (this.popupActive = '')
      }
      if (val === true) {
        let result = await this.saveFile(3) //保存项目
        if (result && result.isSuccess) {
          // this.$message.success(result.returnMsg)
        } else {
          this.$message.error(result.returnMsg)
        }
      }
      //退出操作
      switch (leaveType) {
        case 'back': {
          this.$router.push({
            name: 'course-details',
            query: { curriculumId, trainingId: this.trainingId },
          })
          // this.$router.go(-1)
          break
        }
        default: {
          this.$router.push('/')
          break
        }
      }
      this.leaveType = ''
      this.popupActive = ''
    }, 300),

    // 实训报告  @data trainingId userId学生id
    // async TrainingReport() {
    //   let { trainingId, studentId } = this,
    //     userId = this.studentId || this.accountInfo.userId,
    //     data = {
    //       trainingId,
    //       userId: userId,
    //     },
    //     res
    //   res = await MARKCENTER.TrainingReport(data)
    //   if (res && res.isSuccess) {
    //     this.projectTask = res.data
    //     if (res.data.score) {
    //       this.homeWorkStatus = true
    //       this.$store.state.blocklyHome.homeWorkStatus = true
    //     } else {
    //       this.homeWorkStatus = false
    //       this.$store.state.blocklyHome.homeWorkStatus = false
    //     }
    //   }
    // },
    //获取媒体（图片、音频、文本）资源
    getMedia() {
      let { trainingId, accountInfo, projectId } = this,
        data = {}
      //实训中心里根据trainingId获取媒体积木
      console.log('trainingId', trainingId)

      if (trainingId) {
        data = {
          trainingId,
          userId: accountInfo.userId,
        }
        return BLOCK.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      } else if (projectId) {
        //ai-T编辑器里根据trainingId获取媒体积木
        data = {
          projectId,
        }

        return AI_EDITOR.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      }
    },
    //保存项目文件功能 runType 保存或者是另存为，显示提示不一样
    async saveFile(type, runType) {
      let self = this,
        { trainingId, isComplete, isPublic, userRole } = this,
        pythonCodeText,
        result,
        msg =
          type === 1
            ? '提交代码成功'
            : type === 2
            ? '提交题面成功'
            : type === 3
            ? '保存成功'
            : type === 4
            ? '提交作业成功'
            : '提交成功',
        data = {
          buildingBlocksType: type,
          trainingId,
          userRole,
          isComplete: isComplete,
          isPublic,
        }
      if (this.$refs.blocklyIndex) {
        let xml = this.$refs.blocklyIndex.$refs.blockly.workspaceToDom() //工作台上的积木
        data.buildingBlocks = xml.outerHTML
      } else {
        data.buildingBlocks = ''
      }
      /**
       *  @data buildingBlocks 项目积木;
       * buildingBlocksType 积木类型：1项目题解，2项目题面，3基础模型，4提交作业
       *  isComplete 是否完成：1完成，0未完成
       * isPublic 是否公开：1公开，0不公开
       *  pid：预留字段
       *  trainingId 实训id
       */

      // 获取积木的python脚本 并运行脚本，脚本运行成功才能往下执行
      if (this.$refs.blocklyIndex) {
        pythonCodeText = this.runHandle()
      } else if (this.pythonEditorCode) {
        pythonCodeText = this.pythonEditorCode
      }
      if (pythonCodeText) {
        this.codeText = pythonCodeText
        data.pythonBlocks = pythonCodeText
      } else {
        data.pythonBlocks = ''
      }

      if (userRole != 2) {
        // 老师角色
        switch (type) {
          case 1: {
            /**提交代码*/
            data.isComplete = 1
            data.isPublic = 1
            let runRes = await this.$refs.codeRun.codeRunHandle()
            // console.log('runRes', runRes)
            if (this.runMode != 'frontEnd' && (!runRes || !runRes.isSuccess)) {
              this.$message.error('编译不成功，请重新编译')
              return false
            }

            result = await BLOCK.submitProjectCode(data)
            if (result && result.isSuccess) {
              //保存积木代码
              this.saveFile(3)
              //重新获取项目解法
              bus.$emit('getProjectExplanation') //更新项目解法
              bus.$emit('getTrainingByTrainingId') //更新实训状态;

              this.$message.success(result.returnMsg || msg)
            } else {
              this.$message.error(result.returnMsg)
            }
            break
          }
          case 2: {
            /**提交题面*/
            data.isComplete = 1
            data.isPublic = 1
            result = await BLOCK.saveProjectCode(data)
            if (result && result.isSuccess) {
              bus.$emit('getProjectQuestion') //更新项目题面
              this.$message.success(result.returnMsg || msg)
            } else {
              this.$message.error(result.returnMsg)
            }
            break
          }
          case 3: {
            /**保存代码*/
            data.isComplete = 0
            data.isPublic = 0
            result = await BLOCK.saveProjectCode(data)
            if (result && result.returnCode == 200) {
              self.$message.success(result.returnMsg)
            } else {
              self.$message.error(result.returnMsg)
            }
            break
          }
          default:
            break
        }
      } else {
        //学生角色
        switch (type) {
          case 4: {
            /**提交代码（学生自评）*/
            data.isComplete = 1
            data.isPublic = 0
            result = await BLOCK.submitProjectCode(data)
            if (result && result.isSuccess) {
              this.$message.success(result.returnMsg || msg)
            } else {
              this.$message.error(result.returnMsg)
            }
            break
          }
          case 3: {
            /**保存代码*/
            data.isComplete = 0
            data.isPublic = 0
            result = await BLOCK.saveProjectCode(data)
            if (result && result.returnCode == 200) {
              self.$message.success(result.returnMsg)
            } else {
              self.$message.error(result.returnMsg)
            }
            break
          }
          case 1: {
            /**保存为项目题解*/
            data.isComplete = 1
            data.isPublic = 0
            //提交题解前先运行代码
            let runRes = await this.$refs.codeRun.codeRunHandle()
            if (this.runMode != 'frontEnd' && (!runRes || !runRes.isSuccess)) {
              return this.$message.error('只有编译成功了才能发表项目解法')
            }

            result = await BLOCK.saveProjectCode(data)
            if (result && result.isSuccess) {
              this.$message.success(result.returnMsg || msg)
            } else {
              this.$message.error(result.returnMsg)
            }
            break
          }
          default:
            break
        }
      }

      return result
    },
    //提交代码接口和提交题解接口
    async submitCode(type) {
      let userRole = this.userRole
      if (userRole === 2 && this.homeWorkStatus) {
        this.popupActive = 'report'
      } else {
        if (userRole != 2) {
          //老师时，直接提交代码
          await this.saveFile(type)
          //同时执行保存代码
          this.saveFile(3)
        } else if (userRole == 2) {
          //学生时，需要弹出自评弹框，然后再提交代码
          this.popupActive = 'score'
          if (this.homeWorkStatus) {
            this.scoreTitle = '实训报告'
          }
        }
      }
    },
    //点开老师评分弹窗
    socreProject2() {
      if (this.homeWorkStatus) {
        this.popupActive = 'report'
      } else {
        this.popupActive = 'score'
      }
    },
    activeSelectProject(projectId) {
      this.redirectToTraining(projectId)
      this.reload()
    },
    // 跳转
    redirectToTraining(projectId) {},
    // 自我评价
    saveAddSubmitProject() {},
    // 重命名
    saveCopyProject() {},
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      if (switchObj.type == 'codeRun') {
        this.codeRunSwitch = switchObj
      } else if (switchObj.type == 'guideBook') {
        this.guideBookSwitch = switchObj
      }
      this.sidebarSwitch = switchObj.sidebarSwitch
      if (window) {
        this.$nextTick(() => {
          // window.dispatchEvent(new Event("resize"));
          var resizeEvent = window.document.createEvent('UIEvents')
          resizeEvent.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(resizeEvent)
        })
      }
    },
    // 切换codeRun和guideBook区域并进行重绘
    swichRightSide() {
      if (this.rightSideVal === 'codeRun') {
        this.rightSideVal = 'guideBook'
        this.$store.state.blocklyHome.rightSideVal = 'guideBook'
        this.sidebarSwitchHandle(this.guideBookSwitch)
        this.$nextTick(() => {
          this.$refs.guideBook.sidebarSwitchHandle('guideBook')
        })
      } else {
        this.rightSideVal = 'codeRun'
        this.$store.state.blocklyHome.rightSideVal = 'codeRun'
        this.sidebarSwitchHandle(this.codeRunSwitch)
        this.$nextTick(() => {
          this.$refs.codeRun.sidebarSwitchHandle('codeRun')
        })
      }
    },
  },
  beforeDestory() {
    console.log('nihao--------------')
  },
  destroyed() {
    bus.$off('aiEditorSaveFile')
    bus.$off('beforeLeave')
    bus.$off('changeRightSide')
    bus.$off('changeWorkspace')
  },
}
